/**
 * Round off a number to a specific number of decimal places by multiplying them to an exponential
 * so that floating point comparisons and rounding doesn't have an impact on the result
 *
 * @param value the value to round off
 * @param decimalPlaces the number of decimal places to keep
 * @returns The number multiplied by the exponential to the number of decimal places rounded to
 * an integer value
 */
const exponentialRound = decimalPlaces => value => Math.round(value * 10 ** decimalPlaces);
/**
 * Checks if a number is within a bound by rounding to a specific number of decimal places
 * and comparing using exponential rounding
 */


const isInBound = (decimalPlaces, value, lower, upper) => {
  const exp = exponentialRound(decimalPlaces);
  const eValue = exp(value);
  const eLower = exp(lower);
  const eUpper = exp(upper);
  return eValue >= eLower && eValue <= eUpper;
};
/**
 * Create a scale that takes a continuous value and converts it to a discrete result - the scale is
 * indifferent to the specific result as well as ensuring that the input value is converted to a
 * specific number of decimal places
 *
 * > Note that the rounding used for decimal places is `toFixed`, this does the best that is
 * > possible with JS floating point numbers, but it is not perfect
 *
 * @param bounds the bounds of the scale
 * @param decimalPlaces the number of decimal places to round the value to before finding the bound.
 *
 * @returns a function that can be used as a scale for the given bounds. Scales checking will
 * be inclusive of the upper and lower bound values (since this is how the scale is defined)
 */


export const createScale = (bounds, decimalPlaces) => {
  const scale = value => {
    const result = bounds.find(bound => isInBound(decimalPlaces, value, bound.lower, bound.upper));

    if (!result) {
      throw new Error(`${value} does not exist in scale`);
    }

    return result.score;
  };

  return scale;
};
//# sourceMappingURL=index.js.map